import { array, object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { acrissGroupFormData } from "Pages/OneWay/AcrissGroups/@signals"


const schema = object({
	name: string().required('Name is required'),
	acriss: array().min(1, 'At least one acriss is required'),
})

export default function useAcrissGroupsValidator() {
	const { isValid, errors } = useValidatorSeeker(acrissGroupFormData.value, schema)

	return {
		isValid,
		nameError: errors.name || null,
		acrissError: errors.acriss || null,
	}
}
